import { describeServerError, requestBulkReceipts } from "../../../services/managerApi";

/**
 * Ouvre les reçus d'une ou plusieurs commandes.
 *
 * Le piège : l'URL n'est connue qu'après l'appel réseau, mais un
 * `window.open()` lancé après un `await` n'est plus rattaché au clic de
 * l'utilisateur — les navigateurs le bloquent comme une pop-up et rien ne se
 * passe, sans erreur visible. On ouvre donc l'onglet *pendant* le geste, puis
 * on l'envoie sur l'URL une fois reçue. S'il n'y a rien à ouvrir, on le referme.
 *
 * `noopener` est volontairement absent : avec cette option `window.open`
 * renvoie `null` et on perd la référence nécessaire pour naviguer ensuite.
 */
export const openReceipts = async ({ authUser, orderIds }) => {
  if (!orderIds || orderIds.length === 0) {
    return { ok: false, reason: "empty-selection" };
  }

  const popup = window.open("", "_blank");

  try {
    const url = await requestBulkReceipts({ authUser, orderIds });

    if (!url) {
      if (popup) popup.close();
      return { ok: false, reason: "no-url" };
    }

    if (popup) {
      popup.location = url;
    } else {
      // Pop-up bloquée malgré tout : on navigue dans l'onglet courant plutôt
      // que d'abandonner silencieusement.
      window.location.assign(url);
    }

    return { ok: true, url };
  } catch (error) {
    if (popup) popup.close();
    return { ok: false, reason: "request-failed", error, detail: describeFailure(error) };
  }
};

/**
 * Message lisible pour un échec de reçu.
 *
 * Délègue à `describeServerError`, qui déplie les cinq formes de corps d'erreur
 * de Rails. La version locale interpolait `body.error` directement et rendait
 * « [object Object] » sur tout corps structuré — c'est-à-dire précisément ceux
 * qui portent le message utile.
 */
export const describeFailure = (error) => describeServerError(error) || "network";
